import { CashFlowFrameDialogServiceBank } from './cashFlowFrameDialogFormBank';

const cashFlowIframeDialogMembershipBillingInformationBank = {

    CashFlowFrameDialogServiceBank: null,

    init: function() {
        this.CashFlowFrameDialogServiceBank = new CashFlowFrameDialogServiceBank();
    },

    openDialog: function(cashFlowIframeDialogOptions, callback) {
        this.init();

        this.CashFlowFrameDialogServiceBank.open(
            function(form, data) {
                callback(data);
            },
            {
                dialogOptions: {
                    title: '<b>Enter Bank Account to Store on File</b>',
                    caProUI: true,
                    staticForm: false,
                },
                cashFlowIframeDialogOptions: cashFlowIframeDialogOptions
            }
        );
    },
};

export default cashFlowIframeDialogMembershipBillingInformationBank;
